export const StepsFirmaDocumento = Object.freeze({
  POSICION_FIRMA: 0,
  CERTIFICADO_DIGITAL: 1,
  FIRMAR: 2
});
